<template>
  <div :id="formId" class="form-id">
    <form id="anketaForm" v-on:submit.prevent>
      <!-- Ime in priimek starša -->
      <div class="form-inputs" v-if="!submitSuccess && !submitError">
        <label>Ime in priimek starša:</label>
        <input
          id="imeStarsa"
          type="text"
          placeholder="Vnesite ime in priimek starša"
          required
          v-model="imeStarsa"
        />
        <!-- Ime in priimek otroka -->
        <label>Ime in priimek otroka:</label>
        <input
          id="imeOtroka"
          type="text"
          placeholder="Vnesite ime in priimek otroka"
          required
          v-model="imeOtroka"
        />

        <!-- Izbira razreda, v katerem je učenec -->
        <p>Razred, ki ga trenutno obiskuje?</p>
        <input type="radio" id="razredA" name="razred" value="razredA" required v-model="razred" />
        <label for="razredA">{{ razredNum }}. A</label>
        <input type="radio" id="razredB" name="razred" value="razredB" required v-model="razred" />
        <label for="razredB">{{ razredNum }}. B</label>

        <!-- Prešolanje otroka -->
        <p>Ali nameravate otroka s prihodnjim šolskim letom prešolati?</p>
        <input
          type="radio"
          id="presolanjeYes"
          name="presolanje"
          value="da"
          @click="presolanje"
          required
          v-model="presolanjeData"
        />
        <label for="presolanjeYes">DA</label>
        <input
          type="radio"
          id="presolanjeNo"
          name="presolanje"
          value="ne"
          @click="presolanje"
          required
          v-model="presolanjeData"
        />
        <label for="presolanjeNo">NE</label>

        <!-- Jutranje varstvo -->
        <div id="jutranjeVarstvo" v-if="!presolanjeSelected && jutranjeShow">
          <p>
            Ali bo otrok obiskoval
            <strong>jutranje varstvo</strong>, ki je organizirano od 6:30 do 8:10?
          </p>
          <input
            type="radio"
            id="jutranjeYes"
            name="jutranje"
            value="da"
            @click="jutranje"
            v-model="jutranjeVarstvo"
            required
          />
          <label for="jutranjeYes">DA</label>
          <input
            type="radio"
            id="jutranjeNo"
            name="jutranje"
            value="ne"
            @click="jutranje"
            v-model="jutranjeVarstvo"
            required
          />
          <label for="jutranjeNo">NE</label>
        </div>

        <transition name="fade">
          <div id="podaljsano" v-if="!presolanjeSelected && jutranjeSelected && jutranjeShow">
            <p>Če bo otrok vključen v jutranje varstvo, vas prosimo, da napišete ob kateri uri bo otrok prihajal v šolo? Zadnji čas za prihod v jutranje varstvo je 7:30.</p>
            <label>Prihajal bo ob:</label>
            <input
              type="text"
              id="jutranjePrihod"
              v-model="jutranjePrihod"
              placeholder="Vnesite čas prihoda v jutranje varstvo"
              required
            />
          </div>
        </transition>

        <!-- Podaljšano bivanje -->
        <transition name="fade">
          <div id="podaljsano" v-if="!presolanjeSelected">
            <p>Ali bo vaš otrok vključen v podaljšano bivanje?</p>
            <input
              type="radio"
              id="podaljsanoYes"
              name="podaljsano"
              value="da"
              @click="podaljsano"
              v-model="podaljsanoBivanje"
              required
            />
            <label for="podaljsanoYes">DA</label>
            <input
              type="radio"
              id="podaljsanoNo"
              name="podaljsano"
              value="ne"
              @click="podaljsano"
              v-model="podaljsanoBivanje"
              required
            />
            <label for="podaljsanoNo">NE</label>
          </div>
        </transition>

        <!-- Čas podaljšanega bivanja -->
        <transition name="fade">
          <div id="casPodaljsano" v-if="podaljsanoSelected && !presolanjeSelected">
            <p>Če bo vključen v podaljšano bivanje, prosimo napišite, do katere ure bo ostajal v šoli:</p>
            <div v-if="!podaljsanoCasCetrtosolci">
              <input
                type="radio"
                id="predMalico"
                value="14:40"
                name="casPodaljsano"
                v-model="casPodaljsanoBivanje"
                required
              />
              <label for="predMalico">14:40</label>
              <input
                type="radio"
                id="vmes"
                value="15:30"
                name="casPodaljsano"
                v-model="casPodaljsanoBivanje"
                required
              />
              <label for="vmes">15:30</label>
              <input
                type="radio"
                id="predMalico"
                value="16:30"
                name="casPodaljsano"
                v-model="casPodaljsanoBivanje"
                required
              />
              <label for="poMalici">16:30</label>
            </div>
            <div v-else>
              <input
                type="radio"
                id="predMalico"
                value="14:40"
                name="casPodaljsano"
                v-model="casPodaljsanoBivanje"
                required
              />
              <label for="predMalico">14:40</label>
              <input
                type="radio"
                id="poMalici"
                value="15:00"
                name="casPodaljsano"
                v-model="casPodaljsanoBivanje"
                required
              />
              <label for="poMalici">15:00</label>
            </div>
          </div>
        </transition>

        <input type="hidden" :value="formId" id="anketaType" />
        <button type="submit" id="submitBtn" @click="saveEntry">Potrdi vnos</button>
      </div>
    </form>
    <div id="submitSuccess" v-if="submitSuccess">
      <i class="fas fa-check"></i>
      <h2>Hvala za vaš odgovor in ostanite zdravi.</h2>
    </div>
    <div id="submitError" v-if="submitError">
      <i class="fas fa-times"></i>
      <h2>Prišlo je do napake pri oddaji ankete.</h2>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
import firebase from "firebase";

export default {
  name: "Form",
  props: ["formId"],
  watch: {
    $route(to, from) {
      // react to route changes...
      console.log(to);
      console.log(from);
    }
  },
  data() {
    return {
      podaljsanoSelected: false,
      presolanjeSelected: false,
      jutranjeSelected: false,
      submitSuccess: false,
      submitError: false,
      imeStarsa: undefined,
      imeOtroka: undefined,
      razred: null,
      presolanjeData: null,
      podaljsanoBivanje: null,
      casPodaljsanoBivanje: null,
      jutranjeVarstvo: null,
      jutranjePrihod: null,
      razredNum: null,
      podaljsanoCasCetrtosolci: false,
      jutranjeShow: false
    };
  },
  mounted() {
    var routerName = document.querySelector(".form-id").id;

    if (routerName === "četrtošolci") {
      this.razredNum = "4";
      this.podaljsanoCasCetrtosolci = true;
    } else if (routerName === "tretješolci") {
      this.razredNum = "3";
    } else if (routerName === "drugošolci") {
      this.razredNum = "2";
    } else {
      this.razredNum = "1";
      this.jutranjeShow = true;
    }

setTimeout(function () {     console.log(firebase.auth().currentUser);
 }, 1000)
  },
  methods: {
    presolanje: function(event) {
      var that = this;

      if (event.target.id === "presolanjeYes") {
        that.presolanjeSelected = true;
      } else {
        that.presolanjeSelected = false;
      }
    },

    podaljsano: function(event) {
      var that = this;

      if (event.target.id === "podaljsanoYes") {
        that.podaljsanoSelected = true;
      } else {
        that.podaljsanoSelected = false;
      }
    },

    jutranje: function(event) {
      var that = this;

      if (event.target.id === "jutranjeYes") {
        that.jutranjeSelected = true;
      } else {
        that.jutranjeSelected = false;
      }
    },

    saveEntry: function() {
      let that = this;
      var anketaType = document.getElementById("anketaType").value,
        anketaForm = document.getElementById("anketaForm");

      if (anketaForm.checkValidity()) {
        firebase
          .database()
          .ref(
            "anketa/" + anketaType + "/" + this.razred + "/" + this.imeOtroka
          )
          .set(
            {
              imeInPriimekStarsa: this.imeStarsa,
              imeInPriimekUcenca: this.imeOtroka,
              razred: this.razred,
              presolanje: this.presolanjeData,
              podaljsanoBivanje: this.podaljsanoBivanje,
              casPodaljsanoBivanje: this.casPodaljsanoBivanje,
              jutranjeVarstvo: this.jutranjeVarstvo,
              jutranjePrihod: this.jutranjePrihod
            },
            function(error) {
              if (error) {
                that.submitError = true;
              } else {
                that.submitSuccess = true;
              }
            }
          );
      }
    }
  }
};
</script>

<style lang="less" scoped>
form {
  margin-top: 50px;
  text-align: left;
  width: 800px;
  margin: 0 auto;

  @media screen and (max-width: 1024px) {
    width: 100%;
  }

  .form-inputs > label:nth-of-type(1),
  .form-inputs > label:nth-of-type(2) {
    display: block;
    margin-bottom: 10px;
  }

  p {
    margin-top: 20px;
  }
}

input[type="text"] {
  outline: 0;
  border: 0;
  padding: 10px;
  font-size: 14px;
  border-radius: 4px;
  width: 300px;
  border: 1px solid #ccc;
  transition: ease-in-out all 0.3s;

  &:focus {
    box-shadow: 10px 10px 15px #eee;
    transition: ease-in-out all 0.3s;
  }

  @media screen and (max-width: 1024px) {
    width: 90%;
  }

  &:nth-of-type(1) {
    margin-bottom: 20px;
  }

  &:nth-of-type(2) {
    margin-bottom: 10px;
  }
}

label {
  margin-right: 20px;
  font-weight: 600;
}

input[type="radio"] {
  margin-right: 5px;
}

button[type="submit"] {
  background-color: #6cb71a;
  color: white;
  outline: 0;
  border: 0;
  font-size: 18px;
  padding: 14px 15px;
  width: 200px;
  margin-top: 20px;
  box-shadow: 0px 10px 15px #ccc;
  margin-bottom: 40px;
  margin-top: 30px;
  display: block;
}

#submitSuccess,
#submitError {
  margin: 40px 0;

  i {
    font-size: 36px;
  }
}

#submitSuccess {
  i,
  h2 {
    color: #6cb71a;
  }
}

#submitError {
  i,
  h2 {
    color: red;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>